import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old rate-limiting feature URL → export integrations. */
export const Route = createFileRoute('/_marketing/rate-limiting')({
  beforeLoad: () => {
    throw redirect({ to: '/export-integrations', replace: true });
  },
});
